<template>
  <div class="single-specs">
    <div class="title">
      <span class="col">规格名称</span>
      <span class="col">规格类型</span>
      <span class="col2">规格值</span>
      <span class="col">是否填写</span>
      <span class="col">操作</span>
    </div>
    <div class="row" v-for="(item, i) in value" :key="i">
      <Select
        class="col"
        v-model="item.code"
        filterable
        allow-create
        @on-create="(value) => handleCreate(value, item, 'code')"
        @on-change="
          (code) => {
            attrCodeChanged(code, item)
          }
        "
      >
        <Option
          v-for="option in options"
          :key="option.code"
          :value="option.code"
          >{{ option.name }}</Option
        >
      </Select>
      <template v-if="item.code">
        <Select v-model="item.type" class="col">
          <Option :value="1">单选</Option>
          <Option :value="2">多选</Option>
        </Select>
        <Select
          class="col2"
          v-model="item.valsSelect"
          multiple
          filterable
          allow-create
          :max-tag-count="3"
          @on-create="(value) => handleCreate(value, item, 'valsSelect')"
          @on-change="
            (values) => {
              onValsChanged(values, item)
            }
          "
        >
          <Option
            v-for="option in item.valsOptions"
            :value="option.value"
            :key="option.value"
            >{{ option.value }}</Option
          >
        </Select>
        <span class="col">
          <i-switch v-model="item.input" />
        </span>

        <span class="col">
          <Button
            icon="md-trash"
            @click="removeItem(i)"
            long
            class="remove-btn"
          />
        </span>
      </template>
    </div>

    <Button
      v-if="showAddButton"
      icon="md-add"
      @click="addItem"
      long
      class="add-btn"
    />
  </div>
</template>
<style lang="stylus" scoped>
.single-specs
  .col
    flex 1
    text-align center

  .col2
    flex 2.5

  .title
    display flex
    justify-content space-around
    height 35px
    align-items center

    .col2
      text-align center

  .row
    width 100%
    display flex
    margin-bottom 10px

    .remove-btn
      width 50px
      margin-left 10px
</style>
<script>
export default {
  props: ['value', 'options', 'max'],
  data() {
    return {
      showAddButton: true,
      itemRawData: {},
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (!newValue) return
        if (this.max && newValue.length >= this.max) {
          this.showAddButton = false
        } else {
          this.showAddButton = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addItem() {
      if (this.options.length === 0)
        return this.$Message.warning(
          '未选择分类或该分类下暂无规格可选，请通知平台添加'
        )
      let newValueItem = {
        code: '',
        name: '',
        type: 1,
        input: false,
        vals: [],
        valsSelect: [],
        valsOptions: [],
      }
      this.$emit('input', [...this.value, newValueItem])
    },
    removeItem(i) {
      // if (this.value.length === 1)
      //   return this.$Message.warning('至少需要1条数据')
      this.$delete(this.value, i)
      localStorage.setItem('extraSpecs', [])
    },
    attrCodeChanged(code, item) {
      item.valsSelect = []
      item.valsOptions = []
      let attr = this.options.find((item) => item.code === code)
      if (attr) {
        item.name = attr.name
        item.valsOptions = attr.vals
      }
    },
    onValsChanged(values, item) {
      item.vals = []
      values.forEach((attrValue) => {
        let attr = item.valsOptions.find((option) => option.value === attrValue)
        item.vals.push({
          value: attr.value,
          symbol: attr.symbol,
          type: attr.type,
        })
        localStorage.setItem('extraSpecs', JSON.stringify(this.value))
        // this.$emit('inputExtra', [...this.value])
      })
    },
    handleCreate(value, rowItem, prop) {
      if (prop === 'code') {
        this.options.push({
          code: value,
          name: value,
          vals: [],
        })
      } else {
        const rowItemOption = this.options.find(
          (item) => item.code === rowItem.code
        )
        rowItemOption.vals.push({
          symbol: value,
          value,
        })
      }
    },
  },
}
</script>
